<div class="wedding-layout">


  <!-- LEFT SIDEBAR -->

  <aside class="wedding-sidebar">


    <div class="brand">

      <h2>
        Weddingly
      </h2>

      <p>
        Wedding Services
      </p>

    </div>



    <nav>


      <a
      routerLink="/wedding-services/category"
      routerLinkActive="active">


        <span class="material-symbols-outlined">
          category
        </span>


        Service Category


      </a>




      <a
      routerLink="/wedding-services/booking-details"
      routerLinkActive="active">


        <span class="material-symbols-outlined">
          event_note
        </span>


        Booking Details


      </a>





      <a
      routerLink="/wedding-services/payment-details"
      routerLinkActive="active">


        <span class="material-symbols-outlined">
          payments
        </span>


        Payment Details


      </a>



    </nav>



  </aside>





  <!-- RIGHT CONTENT -->


  <main class="wedding-content">


      <router-outlet></router-outlet>


  </main>



</div>